import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  objectiveMetricsLength: 0,
  objectiveMetrics: [],
  objectiveMetric: {},
  objectiveMetricError: "",
  formError: "",
};

export default function ObjectiveMetricReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_OBJECTIVE_METRIC:
      return { ...state, loading: action.payload };
    case actions.LOADING_OBJECTIVE_METRIC_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_OBJECTIVE_METRIC:
      return { ...state, saveLoading: action.payload };
    case actions.GET_OBJECTIVE_METRIC:
      return {
        ...state,
        objectiveMetrics: action.payload.objectiveMetrics,
        objectiveMetricsLength: action.payload.objectiveMetricsLength,
      };
    case actions.GET_OBJECTIVE_METRIC_BY_ID:
      return {
        ...state, objectiveMetric: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.OBJECTIVE_METRIC_FAIL:
      return { ...state, objectiveMetricError: action.payload };
    default:
      return state;
  }
}
